
export default {
  routeDetails: {
    routeDetails: 'Detalhes da rota',
    warnings: 'Avisos',
    routes: 'Rotas',
    route: 'Rota',
    segments: 'Segmentos',
    segment: 'Segmento',
    instructions: 'Instruções',
    instruction: 'Instrução',
    name: 'Nome',
    selectRoute: 'Selecionar esta rota',
    selectedRoute: 'Rota selecionada',
    gotoSegment: 'Ir para segmento',
    warningCodes: {
      1: 'Talve haja algumas restrições nas vias que são parte da rota',
      2: 'Há pedágios ao longo da rota',
      3: 'Há um ou mais segmentos que foram traçados como uma linha reta ao longo do percurso. Durações e acessibilidade podem não estar corretas',
      4: 'Pelo menos uma informação extra solicitada não está disponível',
    },
    routeOpacity: 'Route opacity'
  }
}
